import { createSlice } from "@reduxjs/toolkit";

const postPaySlice = createSlice({
  name: "postpay",
  initialState: {
    doctorData: null,
    postPaymentOutstanding: null,
    postPaymentOutstandingCustom: null,
    monthlyPostPayBill: null,
    paymentHistory: null,
    isUpgradeAccessLoading: false,
    isViewUsersLoading: false,
    isGetCustomOutstandingPaymentLoading: false,
    isGetOutstandingAmountLoading: false,
    isGetPaymentHistoryLoading: false,
    isGetPostPayBillLoading: false,
    isPostBillPaymentLoading: false,
  },
  reducers: {
    // Upgrade Access
    upgradeAccessLoading: (state) => {
      state.isUpgradeAccessLoading = true;
    },
    upgradeAccessSuccess: (state, action) => {
      state.singleDoctorData = action.payload;
      state.isUpgradeAccessLoading = false;
    },
    upgradeAccessFailure: (state) => {
      state.isUpgradeAccessLoading = false;
    },
    
    //View Users
    viewUsersLoading: (state) => {
      state.isViewUsersLoading = true;
    },
    viewUsersSuccess: (state, action) => {
      state.doctorData = action.payload;
      state.isViewUsersLoading = false;
    },
    viewUsersFailure: (state) => {
      state.isViewUsersLoading = false;
    },

    //get Outstanding Amount
    getOutstandingAmountLoading: (state) => {
      state.isGetOutstandingAmountLoading = true;
    },
    getOutstandingAmountSuccess: (state, action) => {
      state.postPaymentOutstanding = action.payload;
      state.isGetOutstandingAmountLoading = false;
    },
    getOutstandingAmountFailure: (state) => {
      state.isGetOutstandingAmountLoading = false;
    },

    //get Payment History
    getPaymentHistoryLoading: (state) => {
      state.isGetPaymentHistoryLoading = true;
    },
    getPaymentHistorySuccess: (state, action) => {
      state.paymentHistory = action.payload;
      state.isGetPaymentHistoryLoading = false;
    },
    getPaymentHistoryFailure: (state) => {
      state.isGetPaymentHistoryLoading = false;
    },

    //get custom outstanding payment
    getCustomOutstandingPaymentLoading: (state) => {
      state.isGetCustomOutstandingPaymentLoading = true;
    },
    getCustomOutstandingPaymentSuccess: (state, action) => {
      state.postPaymentOutstandingCustom = action.payload;
      state.isGetCustomOutstandingPaymentLoading = false;
    },
    getCustomOutstandingPaymentFailure: (state) => {
      state.isGetCustomOutstandingPaymentLoading = false;
    },

    // get post pay bill
    getPostPayBillLoading: (state) => {
      state.isGetPostPayBillLoading = true;
    },
    getPostPayBillSuccess: (state, action) => {
      state.monthlyPostPayBill = action.payload;
      state.isGetPostPayBillLoading = false;
    },
    getPostPayBillFailure: (state) => {
      state.isGetPostPayBillLoading = false;
    },

    // post bill payment
    postBillPaymentLoading: (state) => {
      state.isPostBillPaymentLoading = true;
    },
    postBillPaymentSuccess: (state, action) => {
      state.singleDoctorData = action.payload;
      state.isPostBillPaymentLoading = false;
    },
    postBillPaymentFailure: (state) => {
      state.isPostBillPaymentLoading = false;
    },

  },
});

export const {
  //upgrade access
  upgradeAccessLoading,
  upgradeAccessSuccess,
  upgradeAccessFailure,
  //view users
  viewUsersLoading,
  viewUsersSuccess,
  viewUsersFailure,
  //get outstanding amount
  getOutstandingAmountLoading,
  getOutstandingAmountSuccess,
  getOutstandingAmountFailure,
  //get payment history
  getPaymentHistoryLoading,
  getPaymentHistorySuccess,
  getPaymentHistoryFailure,
  //get custom outstanding payment
  getCustomOutstandingPaymentLoading,
  getCustomOutstandingPaymentSuccess,
  getCustomOutstandingPaymentFailure,
  //get post pay bill
  getPostPayBillLoading,
  getPostPayBillSuccess,
  getPostPayBillFailure,
  //post bill payment
  postBillPaymentLoading,
  postBillPaymentSuccess,
  postBillPaymentFailure,
} = postPaySlice.actions;

export default postPaySlice.reducer;
